import {useEffect, useMemo} from 'react'

import {usePaginationUrlParams} from '../../hooks/usePaginationUrlParams'

export const useBuilderPagination = ({
    perPageLimit,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    filterFunction
}) => {
    const {showAll, showNextEntries, getAllEntries, displayedPage} = usePaginationUrlParams()
    const totalItems = useMemo(() => {
        return data?.pages.flat().filter(filterFunction || (() => true)) || []
    }, [data, filterFunction])

    const displayedItems = useMemo(() => {
        return showAll ? totalItems : totalItems.slice(0, perPageLimit * displayedPage)
    }, [totalItems, perPageLimit, showAll, displayedPage])

    const allEntriesDisplayed = useMemo(() => {
        return displayedItems.length === totalItems.length && !hasNextPage
    }, [displayedItems.length, totalItems.length, hasNextPage])

    useEffect(() => {
        if (!isFetchingNextPage) {
            // fetch next page if we are at the end of the list and there are more items to fetch
            // always keep at least perPageLimit amount ready to display next
            if (
                (showAll || displayedItems.length + perPageLimit >= totalItems.length) &&
                hasNextPage
            ) {
                fetchNextPage()
            }
        }
    }, [
        displayedItems.length,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        showAll,
        perPageLimit,
        totalItems
    ])

    return {
        showNextEntries,
        showAll,
        getAllEntries,
        totalItems,
        displayedItems,
        displayedItemsCount: displayedItems?.length,
        allEntriesDisplayed
    }
}
